var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtherServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.594 7.88502C23.7941 8.23124 23.8997 8.62399 23.9001 9.02389V18.1454C23.8997 18.5453 23.7941 18.9381 23.594 19.2843C23.3939 19.6305 23.1062 19.918 22.7599 20.118L14.7785 24.6788C14.4319 24.8789 14.0386 24.9843 13.6383 24.9843M23.594 7.88502C23.3939 7.5388 23.1062 7.2513 22.7599 7.05135L14.7785 2.49057C14.4319 2.29043 14.0386 2.18506 13.6383 2.18506C13.238 2.18506 12.8448 2.29043 12.4981 2.49057L4.51678 7.05135C4.17046 7.2513 3.88281 7.5388 3.68269 7.88502M23.594 7.88502L13.6384 13.5961L3.68269 7.88502M3.68269 7.88502C3.48256 8.23124 3.377 8.62399 3.37659 9.02389V18.1454C3.377 18.5453 3.48256 18.9381 3.68269 19.2843C3.88281 19.6305 4.17046 19.918 4.51678 20.118L12.4981 24.6788C12.8448 24.8789 13.238 24.9843 13.6383 24.9843M13.6383 24.9843V13.5848M18.7692 10.6202L8.85187 4.89525",
    stroke: "#272638",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherServices);
export default __webpack_public_path__ + "static/media/other-services.33b1975e0718d5b26c98f01fe3cf3c6a.svg";
export { ForwardRef as ReactComponent };